import { createRouter, createWebHistory } from "vue-router";

import HomePage from "@/pages/home.vue";
import ShopPage from "@/pages/shop.vue";
import ProductPage from "@/pages/product.vue";
import Library from "@/pages/library.vue";
import AboutUsPage from "@/pages/about-us.vue";
import Returns from "@/pages/return-policy.vue";
import ShippingInfoPage from "@/pages/shipping-info.vue";
import ContactPage from "@/pages/contact.vue";

const routes = [
    { path: "/", name: "home", component: HomePage },
    { path: "/shop", name: "shop", component: ShopPage },
    { path: "/shop/product/:id", name: "product", component: ProductPage, props: true },
    { path: "/library", name: "library", component: Library },
    { path: "/about", name: "about", component: AboutUsPage },
    { path: "/returns", name: "about-us", component: Returns },
    { path: "/shipping", name: "shipping", component: ShippingInfoPage },
    { path: "/contact", name: "contact", component: ContactPage },
];

export default createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});
